import {
  CreateSingleReminderReducer,
  terminateLeaseDataReducer,
  updateLeaseStatusReducer,
} from 'Redux/slices/LeaseSlice';
import { Button, Form, Space } from 'antd';
import { TextField } from 'component/CompIndex';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { routeObj } from 'staticData/Data';
import { getParamId } from 'utils/UtilsIndex';

const Reminders = ({ setIsModalOpen, leaseId }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [form] = Form.useForm();
  const onFinish = (data) => {
    dispatch(CreateSingleReminderReducer({ leaseId }));
    handleCancel();
  };
  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };
  return (
    <div className="center flex-col p-4">
      <p className="text-3xl">Send Reminder</p>
      <br />
      <div className="mb-8">
        <p className="mb-1 mt-[-0.5rem] text-lg">
          Are you sure you wish to send reminder mail?
        </p>
      </div>
      <Form
        layout="vertical"
        size="large"
        onFinish={onFinish}
        form={form}
        className="w-full"
      >
        <Space className="center">
          <Button className="w-auto" onClick={handleCancel}>
            Cancel
          </Button>
          <Button size="large" className="customButton" htmlType="submit">
            Send Mail
          </Button>
          {/* <Button size="large" className="customButton" htmlType="submit">
              Send SMS
            </Button>
            <Button size="large" className="customButton" htmlType="submit">
              Send Both
            </Button> */}
        </Space>
      </Form>
    </div>
  );
};

export default Reminders;
